import { get, post } from "./Api";

export function SearchQuestionnaire() {
  return get({ url: `/api/v1/haire/questionnaire/search` });
}

export function SearchQuestionnaireById({ params }) {
  return get({ url: `/api/v1/haire/questionnaire/search`, params });
}

export function CreateUserAnswer({ data }) {
  return post({ url: `/api/v1/haire/questionnaire/answer`, data });
}